import { callApi } from 'utils/ApiUtil';
import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import { MdResultCondition, MdResultMaster, MdResultDetail } from 'models/md/MdResult';
import { SetupEquipment, SetupEquipmentCondition } from '../../models/setup/SetupEquipment';
import { UtMatrixStandardCode } from '../../models/ut/UtMatrixStandardCode';

/**
 * 투자비관리 > 형개발 투자비 산출 > 투자이력 Dataase 목록 조회
 * @param condition
 * @returns
 */
export const findMdResults = async (condition?: MdResultCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/result`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<MdResultDetail[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdResultDetail[];
};

/**
 * 투자비관리 > 형개발 투자비 산출 > 투자이력 Database 저장
 * @param master
 * @param details
 */
export const saveMdResults = async (master?: MdResultMaster, details?: MdResultDetail[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/result`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: {
      ...master,
      detailList: details,
    },
  };
  const response: CommonResponse = await callApi(request);
  return response;
};

export const findMdResultsMasterById = async (mdRltId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/result/${mdRltId}/master`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<MdResultMaster> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdResultMaster;
};

export const getMdResultsDetailList = async (mdRltId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/result/${mdRltId}/detail`,
    serviceName: ServiceName.ELM_BE,
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as MdResultDetail[];
};

export const deleteMdResultsDetailList = async (deleteData: MdResultDetail[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/result/detail/delete`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: deleteData,
  };
  const response: CommonResponse = await callApi(request);
  return response;
};
